export const selectEvents = (state) => state.eventsReducer.events;
export const selectFilteredEvents = (state)=>state.eventsReducer.filteredEvents
export const selectDetailEvent = (state) => state.eventsReducer.detailPage;

